module.exports = __webpack_public_path__ + "img/vegetable-ramps-190x100.44aa19cd.jpg";